import MissionProgressBar from "../MissionProgressBar";
import { MissionStatCardStyled } from "./styled";
import { formatDisplayNumber } from "utils/functions/number";

const MissionStatCard = ({
  labelTh,
  labelEn,
  value,
  unit = "คน",
  label = "จำนวน",
  percent,
  gradient,
  barHeight,
}) => (
  <MissionStatCardStyled>
    <div className="card_title">{labelTh}</div>
    <div className="card_subtitle">{labelEn}</div>
    <div className="card_value_row">
      <span className="card_label">{label}</span>
      <span className="card_value">{formatDisplayNumber(value)}</span>
      <span className="card_unit">{unit}</span>
    </div>
    <MissionProgressBar percent={percent} gradient={gradient} height={barHeight} />
  </MissionStatCardStyled>
);

export default MissionStatCard;
